import { usePaymentPage } from "@/api/payment-pages"
import { Outlet, useParams } from "react-router-dom"
import Fullscreen from "@/components/layout/fullscreen"
import PayFrame from "./pay-frame"
import { InvoiceStatus } from "@/api/invoices"
import Logo from "@/components/logo"
import { Card, CardContent } from "@/components/ui/card"
import Loader from "@/components/layout/loader"

export default function PayScreen() {
  const { shortId } = useParams()
  const {
    paymentPage,
    title,
    description,
    amount,
    token,
    error,
    isFixedPrice,
  } = usePaymentPage(shortId!)

  if (error) {
    return (
      <div className="flex flex-grow flex-col items-center justify-center">
        <div className="flex flex-col flex-grow items-center justify-center">
          <h1 className="text-2xl font-semibold">Payment page not found</h1>
          <p className="text-gray-400">
            The payment page you are looking for does not exist.
          </p>
        </div>
      </div>
    )
  }

  if (!paymentPage) {
    return <Loader message="Loading payment page" />
  }

  if (
    paymentPage.invoice &&
    paymentPage.invoice.status === InvoiceStatus.PAID
  ) {
    return (
      <div className="flex flex-col gap-4 items-center">
        <Logo />
        <Card>
          <CardContent>
            <div className="flex flex-grow flex-col items-center justify-center">
              <div className="flex flex-col flex-grow items-center justify-center gap-4">
                <h1 className="text-2xl font-semibold">Invoice paid</h1>
                <p className="text-gray-300">
                  The invoice has already been paid
                </p>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    )
  }

  return (
    <Fullscreen>
      <PayFrame
        title={title}
        description={description!}
        amount={isFixedPrice ? amount : undefined}
        token={token}
        userName={paymentPage.user.firstName}
      >
        <Outlet />
      </PayFrame>
    </Fullscreen>
  )
}
